import React from "react";
import { BVRatingStars } from "./BVRatingStars";
import * as styles from "./BVRatingContainer.css";
import { cx } from "emotion";
import PropTypes from "prop-types";

export class BVRatingContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedStar: null
        };
    }

    render() {
        const { className, onSelect, selectedStar } = this.props;
        const { hoveredStar } = this.state;

        let message;
        switch (hoveredStar || selectedStar) {
            case 1:
                message = "Плохо";
                break;
            case 2:
                message = "Удовлетворительно";
                break;
            case 3:
                message = "Нормально";
                break;
            case 4:
                message = "Хорошо";
                break;
            case 5:
                message = "Отлично";
                break;
            default:
                message = "Щелкните, чтобы оценить!";
        }

        return (
            <div className={cx(styles.container, className)}>
                <BVRatingStars
                    selectedStar={selectedStar}
                    className={styles.stars}
                    onSelect={starIndex => {
                        onSelect(starIndex);
                    }}
                    onHover={starIndex => {
                        this.setState({
                            hoveredStar: starIndex
                        });
                    }}
                    hoveredStar={hoveredStar}
                />
                <div className={cx(styles.text, styles.message)}>{message}</div>
            </div>
        );
    }
}

BVRatingContainer.propTypes = {
    className: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    selectedStar: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};